import { AppBar, Box, Button, debounce, Dialog, Grid, ListItem, ListItemText, Paper, TextField, Toolbar, Typography } from "@mui/material"
import { Transition } from "../../../../../../../components"
import { useListaDeduplicacaoService } from "../../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { useState } from "react"
import { FixedSizeList } from "react-window"
import { formatCPF } from "../../../../../../../../utils"
import { EditCPF } from "./EditCPF"
import { ListaDeduplicacaoImportFile } from "./ListaDeduplicacaoImportFile"
import AutoSizer from "react-virtualized-auto-sizer"
import FileIcon from '@mui/icons-material/FileUpload'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

export const EditListaDeduplicacaoForm = (props: {
    openForm: boolean
}) => {
    // State
    const { listaDeduplicacao } = useAppSelector((state) => state)
    // Use State
    const [addCPFValue, setAddCPFValue] = useState<string>('')
    const [cpfSearchTerm, setCPFSearchTerm] = useState<string>('')
    const [oldCPF, setOldCPF] = useState<string>('')
    // Hook
    const {
        closeEditListaDeduplicacaoForm,
        setEditListaDeduplicacaoName,
        addItemToDeduplicacaoList,
        resetListaDeduplicacaoFileData,
        updateListaDeduplicacao,
        listaDeduplicacaoRemoveCPF,
        openEditCPF,
        openImportFileListaDeduplicacao,
        setupListaDeduplicacao
    } = useListaDeduplicacaoService()

    const handleClickOpen = () => {
        openEditCPF(true);
    };

    return (
        <>
            {
                props.openForm === true &&
                <>
                    <Dialog
                        fullScreen
                        open={listaDeduplicacao.openEditListaDeduplicacao}
                        TransitionComponent={Transition}
                        onClose={() => {
                            closeEditListaDeduplicacaoForm()
                            setupListaDeduplicacao()
                        }}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar>
                                <Typography sx={{ ml: 2, flex: 1 }} textTransform="uppercase" variant="h6" component="div">
                                    Editar lista - {listaDeduplicacao.editListaDeduplicacaoForm.fields.Nome}
                                </Typography>
                                <Button
                                    autoFocus
                                    color="inherit"
                                    onClick={() => {
                                        closeEditListaDeduplicacaoForm()
                                        setupListaDeduplicacao()
                                    }}
                                >
                                    Fechar
                                </Button>
                            </Toolbar>
                        </AppBar>
                        <Box p={3}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Nome da lista"
                                        placeholder="Digite o nome da lista"
                                        defaultValue={listaDeduplicacao.editListaDeduplicacaoForm.fields.Nome}
                                        onChange={debounce((e) => {
                                            setEditListaDeduplicacaoName(e.target.value)
                                        }, 500)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper elevation={3}>
                                        <Box p={3}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="h6"
                                                        fontWeight="bold"
                                                        textTransform="uppercase"
                                                        color="primary"
                                                    >
                                                        Adicionar CPF
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        label="Digite o CPF que deseja adicionar"
                                                        value={addCPFValue.length >= 11 ? formatCPF(addCPFValue) : addCPFValue}
                                                        onChange={(e) => {
                                                            setAddCPFValue(e.target.value.replace(/\D/g, ""))
                                                        }}
                                                        InputProps={{
                                                            endAdornment: <>
                                                                <Button
                                                                    type="submit"
                                                                    onClick={() => {
                                                                        addItemToDeduplicacaoList(addCPFValue)
                                                                        setAddCPFValue('')
                                                                    }}
                                                                >
                                                                    Adicionar
                                                                </Button>
                                                            </>
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="h6"
                                                        fontWeight="bold"
                                                        textTransform="uppercase"
                                                        align="center"
                                                        color="primary"
                                                    >
                                                        OU
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <Button
                                                            startIcon={<FileIcon />}
                                                            variant="contained"
                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                openImportFileListaDeduplicacao(true)
                                                                resetListaDeduplicacaoFileData()
                                                            }}
                                                        >
                                                            Importar arquivo
                                                        </Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Pesquisar CPF"
                                        placeholder="Digite o CPF que deseja pesquisar"
                                        fullWidth
                                        value={cpfSearchTerm}
                                        onChange={(e) => {
                                            setCPFSearchTerm(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography color="primary" variant="h6">
                                        Tamanho: {listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.length.toLocaleString('pt-Br')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} height={(listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.length ?? 0) <= 3 ? 175 : 250} maxHeight={400}>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={(listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.length ?? 0) <= 3 ? 175 : 250}
                                                style={{
                                                    maxHeight: 400
                                                }}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.filter((cpf) => {
                                                    if (
                                                        cpfSearchTerm === '' ||
                                                        cpfSearchTerm === undefined ||
                                                        cpf.includes(cpfSearchTerm)
                                                    ) {
                                                        return true
                                                    } else {
                                                        return false
                                                    }
                                                }).length ?? 0}
                                                overscanCount={15}
                                            >
                                                {({ index, style }) => {
                                                    const item = listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.filter((cpf) => {
                                                        if (
                                                            cpfSearchTerm === '' ||
                                                            cpfSearchTerm === undefined ||
                                                            cpf.includes(cpfSearchTerm)
                                                        ) {
                                                            return true
                                                        } else {
                                                            return false
                                                        }
                                                    })[index]

                                                    return (
                                                        <ListItem
                                                            style={style}
                                                            secondaryAction={<>
                                                                <Button
                                                                    style={{
                                                                        marginRight: '10px'
                                                                    }}
                                                                    startIcon={<EditIcon />}
                                                                    onClick={() => {
                                                                        handleClickOpen()
                                                                        setOldCPF(item ?? '')
                                                                    }}
                                                                >
                                                                    Editar
                                                                </Button>
                                                                <Button
                                                                    startIcon={<DeleteIcon />}
                                                                    onClick={() => {
                                                                        listaDeduplicacaoRemoveCPF(item)
                                                                    }}
                                                                >
                                                                    Excluir
                                                                </Button>
                                                            </>
                                                            }
                                                        >
                                                            <ListItemText primary={formatCPF(item)} />
                                                        </ListItem>
                                                    )
                                                }}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            updateListaDeduplicacao()
                                        }}
                                        variant="contained"
                                    >
                                        Salvar alterações
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Dialog>

                    <ListaDeduplicacaoImportFile openImportFile={listaDeduplicacao.openImportFileListaDeduplicacao} />
                    <EditCPF openEditCPF={listaDeduplicacao.openEditCPF} oldCPF={oldCPF} />
                </>
            }
        </>
    )
}